import { isBlocket, isDba, isFinn } from '@borealis/aurora';
import type { Brand } from '@finn-no/mobility-item-insertion-shared';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { usePostalPlace } from '../../hooks/usePostalPlace.js';
import { getHuckConfig } from '../../utils/getHuckConfig.js';
import { ControlledTextFieldWidget, type TextFieldWidgetProps } from './textfield-widget.js';

type PostalcodeWidgetProps = TextFieldWidgetProps;

export const PostalcodeWidget = React.forwardRef<HTMLInputElement, PostalcodeWidgetProps>(
  ({ name, locale, className, ...props }, ref) => {
    const config = getHuckConfig();
    const { clearErrors } = useFormContext();
    const postalPlaceAffix = usePostalPlace();
    const countryValue = useWatch({ name: 'address.country' });

    const maxLengthByBrand: Record<Brand, number> = {
      finn: 4,
      dba: 4,
      blocket: 5,
      bilbasen: 4,
    };

    const postalCodeIsMandatory =
      (countryValue === 'NO' && isFinn(config.brand)) ||
      (countryValue === 'DK' && isDba(config.brand)) ||
      (countryValue === 'SE' && isBlocket(config.brand));

    React.useEffect(() => {
      if (postalPlaceAffix && postalPlaceAffix.length > 0) {
        clearErrors(name);
      }
    }, [postalPlaceAffix]);

    return (
      <div ref={ref} className={`${className} flex gap-12 items-end`}>
        <ControlledTextFieldWidget
          {...props}
          name={name}
          maxLength={maxLengthByBrand[config.brand]}
          autoComplete="postal-code"
          mandatory={postalCodeIsMandatory}
          locale={locale}
        />
        {postalPlaceAffix ? <span className="pb-12 whitespace-nowrap">{postalPlaceAffix}</span> : null}
      </div>
    );
  },
);
